/* global i18n, notify  */

import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
// import { flatten, pathEq, reject, values, compose } from 'ramda'
// import { flatten, values } from 'ramda'
// import { isNotEmpty } from 'ramda-adjunct'
import Button from '../../../../components/Button/Button.jsx'
import { xhrPostErr } from '../../../../helpers/http.js'
import { baseUrl } from '../../../../common/constants.js'

import s from '../../style.module.scss'
const CryptoPay = () => {
  const [form, setForm] = React.useState({})
  const handleForm = (name, value) => {
    setForm({ ...form, [name]: value })
  }

  const dispatch = useDispatch()

  const isUnderPayment = useSelector((state) => state.Cart.isUnderPayment)
  const setIsLoading = (isLoading) => {
    dispatch({
      type: 'Cart.setIsLoading',
      payload: {
        isLoading
      }
    })
  }

  const setItems = (items) => {
    dispatch({
      type: 'Cart.setItems',
      payload: {
        items
      }
    })
  }

  const apiCryptoPay = async () => {
    return xhrPostErr(`${baseUrl}/web/cart/payment/crypto`, form)
  }

  const CryptoPay = async (e) => {
    e.preventDefault()
    setIsLoading(true)

    const dta = await apiCryptoPay()
    if (dta.status === '400') {
      const errorMessage = Object.keys(dta.messages)
        .map(function (x) {
          return dta.messages[x].message
        })
        .join('<br>')

      notify(i18n.t('global_cryptopay_error'), errorMessage, 'error')
    }
    if (parseInt(dta.status) === 200) {
      let message = ''
      if ('message' in dta) {
        message = dta.message
      } else {
        message = i18n.t('global_cryptopya_sucess')
      }
      notify(i18n.t('global_sucess'), message, 'success')
      if ('cart' in dta) {
        setItems(dta.cart)
      }
    }

    if (parseInt(dta.status) === 400) {
      const errorMessage = Object.keys(dta.messages)
        .map(function (x) {
          return dta.messages[x].message
        })
        .join('<br>')
      notify(i18n.t('global_cryptopay_error'), errorMessage, 'error')
    }

    setIsLoading(false)
  }

  return (
    <>
      <h3>{i18n.t('cart_crypto_payment_header')}</h3>
      <div className={s.paymentInfoContainer}>
        <h4>{i18n.t('cart_crypto_payment_info_header')}</h4>
        <div>{i18n.t('cart_crypto_payment_info_text')}</div>
      </div>

      <form id="paymentform_4" className={s.couponuseForm} method="post" onSubmit={CryptoPay}>
        <div className={s.formRow}>
          <div className={s.formRowItem}>
            <label className="smalllabel text-left" htmlFor="Input-51391">
              {i18n.t('your_wallet')}
            </label>

            <input
              className="form-control"
              id="Input-51391"
              type="text"
              name="wallet"
              onChange={(e) => handleForm('wallet', e.target.value)}
            />
          </div>

          <div className={s.formRowItem}>
            <div className={s.bottomButtons}>
              <div className={s.primaryButtons}>
                <Button className={`${s.btnPrimary} btn-primary`} type="submit" disabled={isUnderPayment}>
                  {i18n.t('cart_crypto_pay')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  )
}

export default CryptoPay
